import {MODAL_ACTIONS, MODAL_SEVERITY} from 'utils/constants';
import type {ConfirmActionMoreProps, ToggleModal} from 'types/modals';

export interface LeavePageConfirmation {
    toggleModal: ToggleModal;
    translate: (key: string) => string;
    /** Takes the navigation back, keeping the user on the page. */
    stay: () => void;
    /** Lets the navigation through. */
    leave: () => void;
}

/**
 * The unsaved changes popup every guarded page raises when the user navigates away from it.
 *
 * Stay is its primary action, so every way of closing it that is not the Leave button - Esc and
 * the X among them - keeps the user on the page as Stay does. The Leave button closes the popup
 * on its way out too, and that close must not take the navigation back.
 */
function leavePageConfirmation({toggleModal, translate, stay, leave}: LeavePageConfirmation):
    ConfirmActionMoreProps & Record<string, unknown> {

    let leaving = false;

    return {
        title: translate('popUp.unsavedChangesTitle'),
        description: translate('settings.confirmPageLeave'),
        confirmButtonText: 'popUp.stay',
        cancelButtonText: 'popUp.leave',
        severity: MODAL_SEVERITY.INFORMATION,
        handleAction: () => {
            toggleModal(null);
            stay();
        },
        cancelCallback: () => {
            leaving = true;
            leave();
        },
        closeCallback: () => {
            if (!leaving) {
                stay();
            }
        }
    };
}

/** Raises the unsaved changes popup - see leavePageConfirmation. */
export function confirmLeavingPage(confirmation: LeavePageConfirmation): void {
    confirmation.toggleModal(MODAL_ACTIONS.CONFIRM_ACTION, leavePageConfirmation(confirmation));
}
